export default __webpack_public_path__ + "static/media/fepch.547eeda6.png";